export function sendGATagEvent(event: string, value: string, props: object) {
  window.dataLayer = window.dataLayer || []

  window.dataLayer.push({
    [event]: value,
    ...props,
  })
}
